import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule, Optional, SkipSelf } from "@angular/core";

import {
  CrossStorageModule,
  RuntimeConfigModule
} from "@lantern/app/core/utils";

import { AuthJwtService } from "./auth-jwt.service";
import { AuthGuard } from "./auth.guard";
import { AuthInterceptor } from "./auth.interceptor";
import { AuthService } from "./auth.service";
import { LOCATION } from "./constants";
import { IsAdminGuard } from "./is-admin.guard";

@NgModule({
  imports: [CrossStorageModule, RuntimeConfigModule],
  providers: [
    AuthGuard,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthJwtService,
    IsAdminGuard,
    {
      provide: LOCATION,
      useValue: window.location
    }
  ]
})
export class AuthModule {
  constructor(@Optional() @SkipSelf() guard?: AuthModule) {
    if (guard != null) {
      throw new Error(
        "AuthModule is already loaded. Import it in the root module only."
      );
    }
  }
}
